const SHOW_SOCIAL_PROOF = process.env.REACT_APP_SHOW_SOCIAL_PROOF_BAR === 'true'
const SOCIAL_PROOF_COUNT = 312 // update manually once you have real numbers

export default function Landing({ onGetStarted }) {
  return (
    <div style={styles.container}>
      <div style={styles.inner}>

        {/* Nav */}
        <div style={styles.nav}>
          <div style={styles.logo}>Anchor</div>
          <button style={styles.signInBtn} onClick={onGetStarted}>
            Sign In
          </button>
        </div>

        {/* Social proof bar — hidden until REACT_APP_SHOW_SOCIAL_PROOF_BAR=true and count ≥ 25 */}
        {SHOW_SOCIAL_PROOF && SOCIAL_PROOF_COUNT >= 25 && (
          <div style={styles.socialBar}>
            <span style={styles.socialDot} />
            <span style={styles.socialText}>
              {SOCIAL_PROOF_COUNT.toLocaleString()} men are tracking their recovery right now
            </span>
          </div>
        )}

        {/* Hero */}
        <div style={styles.hero}>
          <div style={styles.badge}>Built for men quitting porn</div>
          <h1 style={styles.headline}>
            Quit porn for good. Starting today.
          </h1>
          <p style={styles.sub}>
            Anchor gives you the streak accountability, in-the-moment urge
            support, and anonymous community you need to quit for good.
          </p>
          <button style={styles.ctaBtn} onClick={onGetStarted}>
            Start for free →
          </button>
          <p style={styles.ctaNote}>Free forever. Pro from $19/mo. 7-day free trial.</p>
        </div>

        {/* Features */}
        <div style={styles.features}>
          {[
            {
              icon: '🔥',
              title: 'Streak Tracking',
              desc: 'Watch the number climb. Day 1. Day 7. Day 30. The first time you hit 90 days, you\'ll feel like a different person — because you are one.',
            },
            {
              icon: '🛡️',
              title: 'Urge Button',
              desc: 'The panic button that\'s killed thousands of urges. Tap it the second you feel one coming. 2 minutes later, it\'s gone.',
            },
            {
              icon: '🤝',
              title: 'Accountability Pods',
              desc: 'Get matched with 4 anonymous guys fighting the same fight. Slip up and they\'ll know by morning. Knowing they\'ll know is half the win.',
            },
            {
              icon: '🧠',
              title: 'AI Coach',
              desc: 'Text it at 3am when you can\'t tell anyone else. It remembers your story, knows your triggers, and never judges. Never sleeps either.',
            },
          ].map((f, i) => (
            <div key={i} style={styles.featureCard}>
              <div style={styles.featureIcon}>{f.icon}</div>
              <h3 style={styles.featureTitle}>{f.title}</h3>
              <p style={styles.featureDesc}>{f.desc}</p>
            </div>
          ))}
        </div>

        {/* Why Anchor works */}
        <div style={styles.whySection}>
          <p style={styles.sectionLabel}>Why Anchor works</p>
          {[
            '🧠 Built on the urge-surfing protocol used by addiction therapists.',
            '🔒 Anonymous by design. No real names, no photos, no email needed in your pod.',
            '💯 7-day free trial. Cancel anytime, no questions asked.',
          ].map((row, i) => (
            <div key={i} style={styles.whyRow}>
              <p style={styles.whyBody}>{row}</p>
            </div>
          ))}
        </div>

        {/* Pricing */}
        <div style={styles.pricing}>
          <p style={styles.sectionLabel}>Simple pricing</p>
          <div style={styles.pricingCards}>

            <div style={styles.pricingCard}>
              <p style={styles.planName}>Free</p>
              <p style={styles.planPrice}>$0</p>
              <div style={styles.planFeatures}>
                {[
                  'Streak tracking',
                  'Urge button',
                  'Daily check-ins',
                ].map((f, i) => (
                  <p key={i} style={styles.planFeature}>✓ {f}</p>
                ))}
              </div>
              <button style={styles.planBtnSecondary} onClick={onGetStarted}>
                Get started free
              </button>
            </div>

            <div style={styles.pricingCardPro}>
              <div style={styles.proBadge}>Most Popular</div>
              <p style={styles.planName}>Pro</p>
              <div style={styles.priceRow}>
                <p style={styles.planPrice}>$19<span style={styles.perMonth}>/mo</span></p>
                <p style={styles.planPriceAlt}>or $99/year</p>
              </div>
              <div style={styles.planFeatures}>
                {[
                  'Everything in Free',
                  'Urge SOS button (unlimited)',
                  'Accountability pods',
                  '24/7 AI recovery coach',
                  'Relapse pattern analytics',
                ].map((f, i) => (
                  <p key={i} style={styles.planFeaturePro}>✓ {f}</p>
                ))}
              </div>
              <button style={styles.planBtnPro} onClick={onGetStarted}>
                Start Pro — 7 day free trial
              </button>
            </div>

          </div>
        </div>

        {/* Bottom CTA */}
        <div style={styles.bottomCta}>
          <h2 style={styles.bottomCtaTitle}>
            Day 1 starts when you decide it does.
          </h2>
          <p style={styles.bottomCtaSub}>
            Join the men using Anchor to take back control — one urge at a time.
          </p>
          <button style={styles.ctaBtn} onClick={onGetStarted}>
            Get started for free →
          </button>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>Anchor · getanchorapp.org</p>
          <p style={styles.footerNote}>
            Not a substitute for professional medical or psychological treatment.
          </p>
        </div>

      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#080812',
    color: '#fff',
  },
  inner: {
    maxWidth: 480,
    margin: '0 auto',
    padding: '0 20px 60px',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    marginBottom: 32,
  },
  logo: {
    fontSize: 18,
    fontWeight: 800,
    color: '#fff',
    fontFamily: 'serif',
  },
  signInBtn: {
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 10,
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
    padding: '8px 16px',
    cursor: 'pointer',
  },
  socialBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    background: 'rgba(124,58,237,0.1)',
    border: '1px solid rgba(124,58,237,0.2)',
    borderRadius: 12,
    padding: '10px 16px',
    marginBottom: 32,
  },
  socialDot: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#4ade80',
    boxShadow: '0 0 6px #4ade80',
    flexShrink: 0,
  },
  socialText: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 13,
    fontWeight: 500,
  },
  hero: {
    textAlign: 'center',
    marginBottom: 56,
  },
  badge: {
    display: 'inline-block',
    background: 'rgba(167,139,250,0.15)',
    border: '1px solid rgba(167,139,250,0.3)',
    borderRadius: 20,
    color: '#a78bfa',
    fontSize: 12,
    fontWeight: 600,
    padding: '4px 14px',
    marginBottom: 20,
    letterSpacing: 0.5,
  },
  headline: {
    fontSize: 36,
    fontFamily: 'serif',
    lineHeight: 1.25,
    margin: '0 0 16px',
    color: '#fff',
  },
  sub: {
    fontSize: 15,
    color: 'rgba(255,255,255,0.55)',
    lineHeight: 1.7,
    marginBottom: 32,
  },
  ctaBtn: {
    display: 'inline-block',
    padding: '16px 32px',
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 14,
    color: '#fff',
    fontSize: 16,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 12,
  },
  ctaNote: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: 12,
    margin: 0,
  },
  features: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 12,
    marginBottom: 48,
  },
  featureCard: {
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 16,
    padding: 20,
  },
  featureIcon: {
    fontSize: 22,
    marginBottom: 10,
  },
  featureTitle: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 700,
    margin: '0 0 6px',
  },
  featureDesc: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 12,
    lineHeight: 1.6,
    margin: 0,
  },
  whySection: {
    marginBottom: 48,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  whyRow: {
    display: 'flex',
  },
  whyBody: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 13,
    lineHeight: 1.65,
    margin: 0,
  },
  pricing: {
    textAlign: 'center',
    marginBottom: 48,
  },
  sectionLabel: {
    color: 'rgba(255,255,255,0.35)',
    fontSize: 11,
    letterSpacing: 2,
    textTransform: 'uppercase',
    marginBottom: 20,
  },
  pricingCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 12,
  },
  pricingCard: {
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 20,
    padding: 20,
    textAlign: 'left',
  },
  pricingCardPro: {
    background: 'linear-gradient(145deg, #1a0a3a, #0a1a3a)',
    border: '1px solid rgba(167,139,250,0.3)',
    borderRadius: 20,
    padding: 20,
    textAlign: 'left',
    position: 'relative',
  },
  proBadge: {
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    borderRadius: 20,
    color: '#fff',
    fontSize: 10,
    fontWeight: 700,
    padding: '3px 10px',
    display: 'inline-block',
    marginBottom: 12,
  },
  planName: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 1,
    textTransform: 'uppercase',
    margin: '0 0 4px',
  },
  priceRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
    marginBottom: 0,
  },
  planPrice: {
    color: '#fff',
    fontSize: 32,
    fontFamily: 'serif',
    margin: '0 0 4px',
  },
  planPriceAlt: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: 11,
    margin: '0 0 12px',
  },
  perMonth: {
    fontSize: 14,
    color: 'rgba(255,255,255,0.4)',
  },
  planFeatures: {
    marginBottom: 20,
  },
  planFeature: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    margin: '0 0 6px',
  },
  planFeaturePro: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 12,
    margin: '0 0 6px',
  },
  planBtnSecondary: {
    width: '100%',
    padding: '10px',
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 10,
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
  },
  planBtnPro: {
    width: '100%',
    padding: '10px',
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 10,
    color: '#fff',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
  },
  bottomCta: {
    textAlign: 'center',
    background: 'rgba(255,255,255,0.02)',
    border: '1px solid rgba(255,255,255,0.06)',
    borderRadius: 24,
    padding: '40px 24px',
    marginBottom: 40,
  },
  bottomCtaTitle: {
    color: '#fff',
    fontFamily: 'serif',
    fontSize: 28,
    margin: '0 0 12px',
  },
  bottomCtaSub: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 14,
    marginBottom: 24,
  },
  footer: {
    textAlign: 'center',
    paddingTop: 20,
    borderTop: '1px solid rgba(255,255,255,0.06)',
  },
  footerText: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: 13,
    margin: '0 0 4px',
  },
  footerNote: {
    color: 'rgba(255,255,255,0.2)',
    fontSize: 11,
    margin: 0,
  },
}
